import { render } from "./ProcessMasterList.vue?vue&type=template&id=3ff08a22&scoped=true"
import script from "./ProcessMasterList.vue?vue&type=script&lang=js"
export * from "./ProcessMasterList.vue?vue&type=script&lang=js"

import "./ProcessMasterList.vue?vue&type=style&index=0&id=3ff08a22&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff08a22"]])

export default __exports__